    @if (open) {
      <div class="fixed inset-0 z-[10001] flex items-end sm:items-center justify-center p-0 sm:p-4" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
        <div class="absolute inset-0 bg-dark-text/60 backdrop-blur-sm" (click)="cancel()"></div>
        <div cntFocusTrap (escape)="cancel()"
          class="relative bg-white rounded-t-3xl sm:rounded-2xl shadow-[0_24px_48px_rgba(0,0,0,0.2)] w-full p-6 md:p-8 max-h-[90dvh] overflow-y-auto {{ size === 'lg' ? 'max-w-lg' : 'max-w-md' }}">
          @if (icon) {
            <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-trinidad/10 mb-4">
              <span aria-hidden="true" class="material-symbols-outlined text-3xl text-trinidad">{{ icon }}</span>
            </div>
          }
          <h2 id="confirm-dialog-title" class="font-headline font-bold text-dark-text text-2xl tracking-tight mb-2">{{ title }}</h2>
          @if (message) {
            <p class="text-sm font-body text-muted-text leading-relaxed mb-6">{{ message }}</p>
          }
          <ng-content></ng-content>
          <div class="flex flex-col-reverse sm:flex-row gap-3 justify-end mt-2">
            <button type="button" (click)="cancel()" [disabled]="cancelDisabled"
              class="w-full sm:w-auto px-5 py-2.5 rounded-full bg-white border border-dark-text/15 text-dark-text text-xs uppercase tracking-[0.12em] font-button font-bold hover:border-dark-text disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
              {{ cancelLabel }}
            </button>
            <button type="button" (click)="confirm()" [disabled]="confirmDisabled"
              class="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-full bg-trinidad text-white text-xs uppercase tracking-[0.12em] font-button font-bold hover:opacity-95 disabled:opacity-40 disabled:cursor-not-allowed shadow-[0_6px_16px_rgba(227,83,13,0.25)] transition-opacity">
              {{ confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    }
